// extracted by mini-css-extract-plugin
export default {"container":"style_container__LibTp","title":"style_title__Mc7PP","desc":"style_desc__obLvT","buttons":"style_buttons__sPAl+","progress":"style_progress__6pmd6"};